'use client'

import { useState } from 'react'
import config from '../../data/site-config.json'

const AMENITIES = [
    { id: 'restaurants', label: '🍽️ Restaurants', query: 'restaurants' },
    { id: 'parks', label: '🌳 Parks', query: 'parks' },
    { id: 'parking', label: '🅿️ Parking', query: 'parking' },
    { id: 'fuel', label: '⛽ Fuel', query: 'fuel+station' },
    { id: 'coffee', label: '☕ Coffee', query: 'coffee+shop' }
]

export default function AmenityMap({ height = 350 }) {
    const [active, setActive] = useState('restaurants')

    const activeAmenity = AMENITIES.find(a => a.id === active)
    const addressQuery = encodeURIComponent(`${config.business.address.street}, ${config.business.address.suburb} ${config.business.address.state} ${config.business.address.postcode}`)
    const embedUrl = `https://maps.google.com/maps?q=${encodeURIComponent(activeAmenity.query)}+near+${addressQuery}&output=embed`

    return (
        <section style={{
            padding: 'var(--spacing-lg) 0',
            background: 'white'
        }}>
            <div className="container" style={{ maxWidth: '1000px' }}>
                <h2 style={{ textAlign: 'center', marginBottom: 'var(--spacing-sm)' }}>
                    Plan Your Visit
                </h2>
                <p style={{ textAlign: 'center', color: 'var(--gray-800)', marginBottom: 'var(--spacing-md)', maxWidth: '600px', margin: '0 auto var(--spacing-md)' }}>
                    See what&apos;s near our Bellevue yard — grab a coffee, find parking, or check out nearby parks while you&apos;re here.
                </p>

                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    gap: '0.5rem',
                    flexWrap: 'wrap',
                    marginBottom: 'var(--spacing-md)'
                }}>
                    {AMENITIES.map(amenity => (
                        <button
                            key={amenity.id}
                            onClick={() => setActive(amenity.id)}
                            style={{
                                padding: '0.5rem 1rem',
                                fontSize: '0.9rem',
                                fontWeight: '600',
                                border: '2px solid',
                                borderColor: active === amenity.id ? 'var(--primary)' : 'var(--gray-200)',
                                background: active === amenity.id ? 'var(--primary)' : 'white',
                                color: active === amenity.id ? 'white' : 'var(--gray-800)',
                                borderRadius: 'var(--border-radius)',
                                cursor: 'pointer',
                                transition: 'all 0.2s ease'
                            }}
                        >
                            {amenity.label}
                        </button>
                    ))}
                </div>

                <div style={{
                    position: 'relative',
                    width: '100%',
                    height: `${height}px`,
                    borderRadius: 'var(--border-radius)',
                    overflow: 'hidden',
                    boxShadow: 'var(--shadow)',
                    background: 'var(--gray-100)'
                }}>
                    <iframe
                        key={active}
                        src={embedUrl}
                        title={`Map showing ${activeAmenity.label} near ${config.business.name}`}
                        width="100%"
                        height={height}
                        style={{
                            border: 0,
                            width: '100%',
                            height: '100%',
                            display: 'block'
                        }}
                        loading="lazy"
                        allowFullScreen
                        referrerPolicy="no-referrer-when-downgrade"
                    />
                </div>
            </div>
        </section>
    )
}
